import { RoleEnum } from '@shared/enum/role.enum';
import { ITradeInSystemItem } from '@shared/interfaces/tradein-system-item.interface';

export const TradeInSytemCollection: ITradeInSystemItem[] = [
  {
    role: RoleEnum.IPS,
    label: 'IPhone para Sempre',
    route: ['ips'],
  },
  {
    role: RoleEnum.TVF,
    label: 'Varejo Fisico',
    route: ['tvf'],
  },
  {
    role: RoleEnum.TVO,
    label: 'Trade-in Online',
    route: ['tvo'],
  },
];
